<script lang="ts">
    import { onMount } from "svelte";
    import * as api from "../lib/api";
    import { toast } from "../lib/toast";
    import Button from "../lib/components/Button.svelte";
    import Badge from "../lib/components/Badge.svelte";

    let events: any[] = [];
    let loading = false;

    async function loadEvents() {
        loading = true;
        try {
            const response = await api.getLoginEvents({
                limit: 200,
                order: "DESC",
            });
            if (response.error) {
                toast.error(response.error.message, "Ошибка");
                return;
            }
            events = response.data ?? [];
        } catch (e: any) {
            toast.error(String(e), "Ошибка");
        } finally {
            loading = false;
        }
    }

    function shortUA(ua: string): string {
        if (!ua) return "—";
        // Достаём наиболее человекочитаемый кусок user-agent.
        const m =
            ua.match(
                /(YaBrowser|Edg|OPR|Chrome|Firefox|Safari)\/[\d.]+/,
            ) || [];
        const os =
            (ua.match(/\(([^)]+)\)/) || [])[1]?.split(";")[0]?.trim() || "";
        const browser = m[0] ? m[0].replace("Edg", "Edge").replace("OPR", "Opera") : "";
        return [browser, os].filter(Boolean).join(" · ") || ua.slice(0, 40);
    }

    onMount(loadEvents);
</script>

<div class="max-w-5xl mx-auto">
    <div class="flex items-center justify-between mb-4">
        <div>
            <h1 class="text-lg font-semibold text-[var(--foreground)]">
                Входы
            </h1>
            <p class="text-sm text-[var(--muted-foreground)]">
                История авторизаций в панели (успешные и неудачные попытки)
            </p>
        </div>
        <Button
            variant="outline"
            size="sm"
            on:click={loadEvents}
            disabled={loading}
        >
            {loading ? "Обновление…" : "Обновить"}
        </Button>
    </div>

    <div
        class="rounded-lg border border-[var(--border)] bg-[var(--card)] overflow-hidden"
    >
        <div class="overflow-x-auto">
            <table class="w-full text-sm">
                <thead>
                    <tr
                        class="text-left text-[var(--muted-foreground)] border-b border-[var(--border)]"
                    >
                        <th class="font-medium px-4 py-2.5">Время</th>
                        <th class="font-medium px-4 py-2.5">Статус</th>
                        <th class="font-medium px-4 py-2.5">Имя</th>
                        <th class="font-medium px-4 py-2.5">IP</th>
                        <th class="font-medium px-4 py-2.5">Устройство</th>
                    </tr>
                </thead>
                <tbody>
                    {#each events as event}
                        <tr
                            class="border-b border-[var(--border)] last:border-0 hover:bg-[color-mix(in_oklch,var(--foreground)_4%,transparent)]"
                        >
                            <td
                                class="px-4 py-2.5 whitespace-nowrap text-[var(--foreground)]"
                            >
                                {new Date(event.createdAt).toLocaleString()}
                            </td>
                            <td class="px-4 py-2.5">
                                {#if event.success}
                                    <Badge variant="success">Успех</Badge>
                                {:else}
                                    <Badge variant="destructive">Отказ</Badge>
                                {/if}
                            </td>
                            <td
                                class="px-4 py-2.5 text-[var(--foreground)] font-mono text-xs"
                            >
                                {event.name || "—"}
                            </td>
                            <td
                                class="px-4 py-2.5 text-[var(--foreground)] font-mono text-xs"
                            >
                                {event.ip || "—"}
                            </td>
                            <td
                                class="px-4 py-2.5 text-[var(--muted-foreground)] text-xs"
                                title={event.userAgent || ""}
                            >
                                {shortUA(event.userAgent)}
                            </td>
                        </tr>
                    {/each}

                    {#if !loading && events.length === 0}
                        <tr>
                            <td
                                colspan="5"
                                class="px-4 py-8 text-center text-[var(--muted-foreground)]"
                            >
                                Событий пока нет
                            </td>
                        </tr>
                    {/if}
                </tbody>
            </table>
        </div>
    </div>
</div>
